var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4412 12.2952L14.1736 0.273787C14.0853 0.186997 13.9804 0.118142 13.8649 0.0711619C13.7494 0.024182 13.6256 0 13.5006 0C13.3755 0 13.2517 0.024182 13.1362 0.0711619C13.0207 0.118142 12.9158 0.186997 12.8275 0.273787L0.559917 12.2952C0.202523 12.6457 0 13.1217 0 13.6182C0 14.6492 0.854767 15.4874 1.9061 15.4874H3.19868V24.0654C3.19868 24.5823 3.62457 25 4.15173 25H11.5945V18.4577H14.9301V25H22.8494C23.3765 25 23.8024 24.5823 23.8024 24.0654V15.4874H25.095C25.6013 15.4874 26.0868 15.2918 26.4442 14.9384C27.1858 14.2082 27.1858 13.0253 26.4412 12.2952Z",
    fill: "#D4307D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNew);
export default __webpack_public_path__ + "static/media/home_new.4423a4b5.svg";
export { ForwardRef as ReactComponent };